import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { InsideSection } from './components/InsideSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-canvas font-sans text-ink" data-id="element-0" data-mp="28tmfb3zlmcxr">
      <Hero data-id="element-1" data-mp="28s2y9b64bxux" />
      <main data-id="element-2" data-mp="23vci6nubd29i">
        <TestimonialsSection data-id="element-3" data-mp="23vuokdaowwv5" />
        <ProblemSection data-id="element-4" data-mp="23ujjma5idj2g" />
        <VolumesSection data-id="element-5" data-mp="23t8heerpojdg" />
        <InsideSection data-id="element-6" data-mp="3ijxoypkvdyjd" />
        <BonusesSection data-id="element-7" data-mp="3ikr0e3urxc7u" />
        <OfferSection data-id="element-8" data-mp="3ijfwm41bw4gq" />
        <GuaranteeSection data-id="element-9" data-mp="3ihv0i9zd8dgr" />
        <FaqSection data-id="element-10" data-mp="3mlaxx8j9ehui" />
        <FinalCtaSection data-id="element-11" data-mp="3mkrcviybbdc9" />
      </main>
      <Footer data-id="element-12" data-mp="3mjq45l4rr2xp" />
      <StickyCta data-id="element-13" data-mp="3mj6jvxrnc2gi" />
    </div>;
}